import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import frontPreview from './corporateActionsCapsuleFrontPreview.png';
import backPreview from './corporateActionsCapsuleBackPreview.png';

export const corporateActionsCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The events capsule displays the historical and upcoming
                corporate actions and holidays for the selected symbol.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Front',
            src: frontPreview,
            altText: 'events-capsule-front-preview',
        },

        {
            title: 'Back',
            src: backPreview,
            altText: 'events-capsule-back-preview',
        },
    ],
};
